import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { Marquee } from './motion/Marquee';
import { testimonials } from '../data/testimonials';
export function ProofMarquee() {
  return <div className="space-y-3" data-id="element-295" data-mp="2xku4wltfn0bq">
      <Marquee speed={42} data-id="element-296" data-mp="2sjobelry7915">
        {testimonials.map(testimonial => <span key={testimonial.id} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border-2 border-line bg-white px-5 py-2.5 text-sm font-bold text-ink shadow-card" data-id="element-297" data-mp="24uc7a0bh9r5p">
            <TrendingUpIcon style={{
          fontSize: 17
        }} className="text-brand-green" data-id="element-298" data-mp="2dva8ybyg1ml4" />
            {testimonial.metric}
            <span className="text-xs font-semibold text-muted" data-id="element-299" data-mp="29vt33hf3unff">
              · {testimonial.name}
            </span>
          </span>)}
      </Marquee>

      <Marquee speed={52} reverse data-id="element-300" data-mp="3l7ty3e2kb83m">
        {testimonials.map(testimonial => <span key={testimonial.id} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brand-blue/[0.06] px-5 py-2.5 text-sm font-semibold text-brand-blue" data-id="element-301" data-mp="2pnelgt3t4nn8">
            <PlaceOutlinedIcon style={{
          fontSize: 16
        }} data-id="element-302" data-mp="2yokz8uf2nkcs" />
            {testimonial.role}
          </span>)}
      </Marquee>
    </div>;
}